import type { ComponentProps } from 'react';
import React from 'react';
import {
  BREAKPOINTS,
  TitleText,
  TYPE_CONFIG,
  useFluidSize,
} from '@sweetgreen/garnish';

export const HeroHeadlineText = React.memo((props: HeroHeadlineProps) => {
  const { children, style, ...rest } = props;

  const fluid = useFluidSize(getLockMinMax(BREAKPOINTS));

  const fluidStyles = {
    fontSize: fluid(TYPE_CONFIG.TITLE['32'].fontSize ?? 32, 56),
    lineHeight: fluid(TYPE_CONFIG.TITLE['32'].lineHeight ?? 36, 56),
    letterSpacing: fluid(TYPE_CONFIG.TITLE['32'].letterSpacing ?? -1.6, -3),
  };

  const styles = [fluidStyles, style];

  return (
    <TitleText style={styles} maxFontSizeMultiplier={1.1} {...rest}>
      {children}
    </TitleText>
  );
});

// ─── Utils ────────────────────────────────────────────────────────

const getLockMinMax = (breakpoints: typeof BREAKPOINTS) => {
  const minBreakpoint = breakpoints[0];
  const maxBreakpoint = breakpoints[3];

  return { min: minBreakpoint.MAX, max: maxBreakpoint.BODY as number };
};

// ─── Types ────────────────────────────────────────────────────────

type HeroHeadlineProps = {
  readonly children: React.ReactText;
} & ComponentProps<typeof TitleText>;
